import React from 'react';
import { Flex, Text, Button, Box, Container } from '@magicpatterns/cubed';
import { LockIcon } from 'lucide-react';
export function Navbar() {
  return <Box className="w-full border-b border-border bg-background sticky top-0 z-50" data-id="element-49">
      <Container size="3" data-id="element-50">
        <Flex align="center" justify="between" px="4" py="3" data-id="element-51">
          <Flex align="center" gap="3" data-id="element-52">
            <img src="https://cdn.magicpatterns.com/uploads/qcbzuL2uSFvgdkx61PWqEY/logo-gradient-dark.png" alt="Magic Patterns" className="h-6" data-id="element-53" />
          </Flex>
          <Flex align="center" gap="3" data-id="element-54">
            <Text size="2" color="gray" className="hidden sm:block" data-id="element-55">
              Start your security review:
            </Text>
            <Button variant="solid" size="2" asChild data-id="element-56">
              <a href="mailto:security@magicpatterns.com" className="inline-flex items-center gap-1.5" data-id="element-57">
                <LockIcon size={14} data-id="element-58" />
                Request Access
              </a>
            </Button>
          </Flex>
        </Flex>
      </Container>
    </Box>;
}